import type { RiskGapModel } from '@ctw/shared/api/fhir/models/risk-gap';
import type { ViewOption } from '@ctw/shared/content/resource/view-option';

// Filter for status
function statusFilter(types: Array<RiskGapModel['status']>) {
  return (data: Array<RiskGapModel>) => data.filter((c) => types.includes(c.status));
}

// Filter for type
function typeFilter(types: Array<RiskGapModel['type']>) {
  return (data: Array<RiskGapModel>) => data.filter((c) => types.includes(c.type));
}

const viewOptions: Array<ViewOption<RiskGapModel>> = [
  {
    display: 'Recapture',
    filters: [typeFilter(['recapture'])],
  },
  {
    display: 'Suspect',
    filters: [typeFilter(['suspect'])],
  },
  {
    display: 'Open',
    filters: [statusFilter(['open-gap'])],
  },
  {
    display: 'Active',
    filters: [statusFilter(['open-gap', 'pending'])],
  },
  {
    display: 'All',
    filters: [(data: Array<RiskGapModel>) => data],
  },
];

const findByDisplay = (display: string) => {
  const found = viewOptions.find((v) => v.display === display);
  if (!found) {
    throw new Error(`View option with display "${display}" not found`);
  }
  return found;
};

export const RiskGapView = {
  viewOptions,
  recapture: findByDisplay('Recapture'),
  suspect: findByDisplay('Suspect'),
  open: findByDisplay('Open'),
  active: findByDisplay('Active'),
  all: findByDisplay('All'),
};
